export default __webpack_public_path__ + "./fonts/logo-home.52038f6d.svg";